import { Component, OnInit, ElementRef, ViewChild, AfterViewInit } from '@angular/core';
import { Player } from '@app/_models/player';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
//import { MatTableDataSource } from '@angular/material/table';
import { PlayersService } from '@app/services/players.service';
import { PlayersDataSource } from '@app/services/players.datasource';

import {debounceTime, distinctUntilChanged, startWith, tap, delay} from 'rxjs/operators';
import {merge, fromEvent} from "rxjs";

@Component({
  selector: 'app-mod-players',
  templateUrl: './mod-players.component.html',
  styleUrls: ['./mod-players.component.scss']
})

export class ModPlayersComponent implements OnInit, AfterViewInit {

  displayedColumns: string[] = ['id', 'nombre', 'email', 'phone', 'reservas', 'partidos', 'more'];
  dataSource: PlayersDataSource;

  resultsLength = 0;
  isLoadingResults = true;
  isRateLimitReached = false;

  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;  
  @ViewChild('searchInput', { static: false }) input: ElementRef;

  constructor(
    private playersService: PlayersService
  ) {}

  ngOnInit() {
    this.dataSource = new PlayersDataSource(this.playersService);
    this.dataSource.loadPlayers('', 'id', 0, 10);
    this.resultsLength = this.dataSource.total;
  }

  ngAfterViewInit() {
    this.resultsLength = this.dataSource.total;
    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);

    fromEvent(this.input.nativeElement,'keyup')
        .pipe(
            debounceTime(250),
            distinctUntilChanged(),
            tap(() => {
                this.paginator.pageIndex = 0;

                this.loadPlayersPage();
            })
        )
        .subscribe();
    
    merge(this.sort.sortChange, this.paginator.page)
    .pipe(
        tap(() => this.loadPlayersPage())
    )
    .subscribe();
  }

  loadPlayersPage() {
      this.dataSource.loadPlayers(
        this.input.nativeElement.value,
        this.sort.active,
        this.paginator.pageIndex,
        this.paginator.pageSize
      );
  }

  /*
  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
  */

}
